const translatedUnits = (key: string) => {
  const data: { [keyof: string]: string } = {
    Gigabytes: 'label.gigabytes',
    Units: 'label.unit',
    Megabytes: 'label.megabytes'
  };
  return data[key] || key;
};

export default translatedUnits;
